module.exports = __webpack_public_path__ + "media/images/yesbank_red_smiley-d07daf4a43ffb440fcb78fa729d6ca5e.svg";